import React from "react";
import { Badge, Modal } from "antd";
import ScheduleTwoTone from "@ant-design/icons/ScheduleTwoTone";
import { useSelector } from "react-redux";
import callGetTaskList from "api/Request/callGetTaskList";
import TaskListModal from "./TaskList";

type NotificationProps = {};

async function fetchTaskCount(userId) {
  if (!userId) return 0;
  try {
    const res = await callGetTaskList();
    console.log(res);
    return Array.isArray(res)
      ? res.filter(
          (x) =>
            x.priority === "risk" && String(x.user_id_b) === String(userId)
        ).length
      : 0;
  } catch (e) {
    return 0;
  }
}

function TaskNotification(props: NotificationProps) {
  const [visible, setVisible] = React.useState(false);
  const [taskCount, setTaskCount] = React.useState(0);
  const userState = useSelector((state) => state.app.userState);
  const userId = userState ? userState.id : null;

  React.useEffect(() => {
    function getTaskCount() {
      fetchTaskCount(userId).then((count) => setTaskCount(count));
    }

    getTaskCount();
    const interval = setInterval(() => {
      getTaskCount();
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, [setTaskCount, userId]);

  function _onClose() {
    setVisible(false);
    fetchTaskCount(userId).then((count) => setTaskCount(count));
  }

  function _onOpen() {
    console.log("open task list modal");
    setVisible(true);
    fetchTaskCount(userId).then((count) => setTaskCount(count));
  }

  return (
    <div className="notification d-inline-block mr-4">
      <a href="javascript: void(0);" onClick={_onOpen}>
        <Badge overflowCount={999} count={taskCount}>
          <ScheduleTwoTone style={styles.icon} />
        </Badge>
      </a>
      <Modal
        title="Danh sách công việc"
        visible={visible}
        onCancel={_onClose}
        footer={null}
        width="95vw"
        style={{ maxWidth: 1600, top: 20 }}
        destroyOnClose
      >
        <TaskListModal
          {...{
            match: {
              params: {},
            },
          }}
        />
      </Modal>
    </div>
  );
}

const styles = {
  icon: {
    fontSize: 25,
    color: "#e4e9f0",
  },
};
export default TaskNotification;
